<template>
    <v-stepper v-model="e1" class="password-stepper transform-password-stepper">
        <v-stepper-items>

            <!-- STEP 1 -->
            <v-stepper-content step="1">
                <v-card class="deposit-form" :class="$vuetify.theme.dark ? 'blue-lighten-2' : 'white-lighten-5'">
                    <v-row dense>

                        <!-- Transfer Method -->
                        <v-col cols="12">
                            <fieldset>
                                <legend>Transfer Method</legend>
                                <v-select v-model="transferType" :items="transferMethods" item-text="text"
                                    item-value="value" label="Select Method" solo class="custom-select" />
                            </fieldset>
                        </v-col>

                        <!-- Available Balance -->
                        <v-col cols="12">
                            <fieldset>
                                <legend>Available Balance (USD)</legend>
                                <v-text-field :value="formattedIBBalance" solo readonly hide-details
                                    class="custom-select" prepend-inner-icon="mdi-cash" />
                            </fieldset>
                        </v-col>

                        <!-- CRYPTO FIELD -->
                        <v-col cols="12" v-if="transferType === 'crypto'">
                            <fieldset>
                                <legend>Select Crypto Address</legend>

                                <p
                                    v-if="!all_crypto || all_crypto.length === 0"
                                    class="mb-0 body-2 pl-3"
                                    style="color: inherit;"
                                >
                                    You need to Create crypto address first
                                </p>

                                <v-select
                                    v-else
                                    v-model="targetCrypto"
                                    :items="all_crypto"
                                    item-text="text"
                                    item-value="value"
                                    label="Select Crypto Address"
                                    solo
                                    class="custom-select"
                                    no-data-text="No crypto address available"
                                />
                            </fieldset>
                        </v-col>

                        <!-- BANK SELECT -->
                        <v-col cols="12" v-if="transferType === 'bank'">
                            <fieldset>
                                <legend>Select Bank</legend>

                                <p
                                    v-if="!all_bank || all_bank.length === 0"
                                    class="mb-0 body-2 pl-3"
                                    style="color: inherit;"
                                >
                                    You need to Create bank account first
                                </p>

                                <v-select
                                    v-else
                                    v-model="selectedBank"
                                    :items="all_bank"
                                    item-text="bank_name"
                                    item-value="id"
                                    solo
                                    class="custom-select"
                                    label="Select Bank"
                                    no-data-text="No bank account available"
                                    @change="fillBank"
                                />
                            </fieldset>
                        </v-col>

                        <!-- AUTO FILLED BANK INFO -->
                        <template v-if="transferType === 'bank' && bank_acc_num">

                            <v-col cols="12">
                                <fieldset>
                                    <legend>Account Name</legend>
                                    <v-text-field v-model="bank_acc_name" solo readonly class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12">
                                <fieldset>
                                    <legend>Account Number</legend>
                                    <v-text-field v-model="bank_acc_num" solo readonly class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12">
                                <fieldset>
                                    <legend>Swift Code</legend>
                                    <v-text-field v-model="bank_swift" solo readonly class="custom-select" />
                                </fieldset>
                            </v-col>

                        </template>

                        <!-- Amount -->
                        <v-col cols="12">
                            <fieldset>
                                <legend>Enter Amount (USD)</legend>
                                <v-text-field v-model="amount" solo hide-details class="custom-select" type="number" />
                            </fieldset>
                        </v-col>

                        <v-col cols="12">
                            <v-btn
                                :loading="isLoading"
                                :disabled="isLoading || isConfirmDisabled"
                                class="btn-account d-block w-100"
                                color="teal-lighten-1"
                                @click="sendOtp"
                            >
                                Confirm
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-card>
            </v-stepper-content>

            <!-- OTP STEP -->
            <v-stepper-content step="2">
                <v-card class="deposit-form">
                    <p class="mb-5">
                        A verification code is sent to
                        <span class="text--green">{{ profile?.email }}</span>
                    </p>

                    <v-row dense>
                        <v-col cols="12">
                            <fieldset>
                                <legend>Enter Verification Code</legend>
                                <v-text-field v-model="otpCode" solo hide-details class="custom-select" />
                            </fieldset>
                        </v-col>

                        <v-col cols="12">
                            <v-btn :loading="isLoading" :disabled="isLoading" class="btn-account w-100"
                                color="teal-lighten-1" @click="verifyOtp">
                                Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

        </v-stepper-items>
    </v-stepper>
</template>


<script>
import toast from "@/services/Notification";
import { mapState, mapActions } from "vuex";
import {
    PROFILE__ACTIONS,
    TRADINGACCOUNTSTOTRANSFER__ACTIONS,
} from "@/store/action-types";

export default {
    data() {
        return {
            e1: 1,
            transferType: null,
            transferMethods: [
                { text: "Crypto Transfer", value: "crypto" },
                { text: "Bank Transfer", value: "bank" },
            ],

            amount: null,
            otpCode: null,
            isLoading: false,

            targetCrypto: null,

            selectedBank: null,
            bank_acc_name: null,
            bank_acc_num: null,
            bank_swift: null,
        };
    },

    computed: {
        ...mapState("tradingaccounts", ["all_crypto", "user_ib_balance", "all_bank"]),
        ...mapState("profile", ["profile"]),

        formattedIBBalance() {
            return Number(this.user_ib_balance || 0).toFixed(2);
        },

        isConfirmDisabled() {
            if (this.transferType === "crypto" && (!this.all_crypto || this.all_crypto.length === 0)) {
                return true;
            }
            if (this.transferType === "bank" && (!this.all_bank || this.all_bank.length === 0)) {
                return true;
            }
            return false;
        },
    },

    methods: {
        ...mapActions("tradingaccounts", [
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRANSFERTOCRYPTOSENDOTP,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMTRANSFERTOCRYPTO,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.BANKTRANSFERSENDOTP,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMBANKTRANSFER,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLCRYPTOADDRESS,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLBANKADDRESS,
            TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER,
        ]),
        ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),

        fillBank(id) {
            const bank = this.all_bank.find(b => b.id === id);
            if (!bank) return;
            this.bank_acc_name = bank.bank_acc_name;
            this.bank_acc_num = bank.bank_acc_num;
            this.bank_swift = bank.bank_swift_num;
        },

        async sendOtp() {
            if (!this.transferType)
                return toast.error("Select transfer method");

            if (!this.amount || this.amount <= 0)
                return toast.error("Enter valid amount");

            if (this.user_ib_balance < this.amount)
                return toast.error("Insufficient balance");

            if (this.transferType === "crypto" && !this.targetCrypto)
                return toast.error("Select crypto address");

            if (this.transferType === "bank") {
                if (!this.selectedBank)
                    return toast.error("Select bank");

                if (this.amount < 50)
                    return toast.error("Minimum amount for bank transfer is 50");
            }

            this.isLoading = true;
            try {
                if (this.transferType === "crypto") {
                    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRANSFERTOCRYPTOSENDOTP]({
                        cryptoId: this.targetCrypto,
                        amount: this.amount,
                    });
                } else {
                    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.BANKTRANSFERSENDOTP]({
                        bank_id: this.selectedBank,
                        amount: this.amount,
                    });
                }

                this.e1 = 2;

            } catch {
                toast.error("Failed to send OTP");
            } finally {
                this.isLoading = false;
            }
        },

        async verifyOtp() {
            if (!this.otpCode)
                return toast.error("Enter OTP");

            this.isLoading = true;

            try {
                const res =
                    this.transferType === "crypto"
                        ? await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMTRANSFERTOCRYPTO]({
                            verification_code: this.otpCode,
                        })
                        : await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMBANKTRANSFER]({
                            verification_code: this.otpCode,
                        });
                if (res?.status) {
                    toast.success("Transfer successful");
                    this.resetForm();
                }
                window.location.reload();

            } catch (error) {
                console.log(error)
                toast.error( error?.response?.data?.message || "OTP verification failed");
                this.resetForm();
            } finally {
                this.isLoading = false;
            }
        },

        resetForm() {
            this.e1 = 1;
            this.transferType = null;
            this.amount = null;
            this.targetCrypto = null;
            this.selectedBank = null;
            this.bank_acc_name = null;
            this.bank_acc_num = null;
            this.bank_swift = null;
            this.otpCode = null;
        }
    },

    watch: {
        selectedBank(val) {
            if (!val) {
                this.bank_acc_name = null;
                this.bank_acc_num = null;
                this.bank_swift = null;
            }
        }
    },

    async mounted() {
        await this[PROFILE__ACTIONS.PROFILE]();
        await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLCRYPTOADDRESS]();
        await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLBANKADDRESS]();
        await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER]();
    },
};
</script>